import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for N501 (客訴單核准-業務組長)
// ============================================================

export interface ApproveCandidate {
  fn110_01: string;   // 客訴單號
  fn110_11: string;   // 客訴日期 (YYYY-MM-DD)
  fn110_12: string;   // 客戶代碼
  fn110_17: string;   // 賠償金額
  fn110_23: string;   // 記錄型態
  fn110_8011: string; // 業務組長意見
}

export interface QueryResponse {
  items: ApproveCandidate[];
  total: number;
}

export interface ApproveItem {
  no: string;      // FN110_01
  opinion: string; // FN110_8011
}

export interface ApproveRequest {
  items: ApproveItem[];
  opinion: string; // 整體意見
}

export interface ApproveResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const n501Api = {
  /** Query complaint records eligible for approval */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/n501/candidates', { params });
    return res.data;
  },

  /** Execute batch approval for selected complaint records.
   * confirmed:true mirrors the Modal.confirm the caller already went through
   * in N501Form (FoxPro's "請確認核准本資料!" dialog) — the backend requires
   * it (backend/modules/n501/models: ApproveRequest.Confirmed). This was
   * previously omitted entirely, so every real approve call failed closed. */
  async approve(request: ApproveRequest): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/n501/approve', { ...request, confirmed: true });
    return res.data;
  },
};
